"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var throttle = require("lodash.throttle");
var debounce = require("lodash.debounce");
var __1 = require("..");
var prosemirror_state_1 = require("prosemirror-state");
var IGNORE_CLOSE_ATTRIBUTE = 'data-syl-toolbar';
// 表格需要特殊处理下rect，否则top和bottom的值一样
var getPosRect = function (view, pos) {
    // CellSelection
    // @ts-ignore
    if (view.state.selection.$anchorCell) {
        return view.domAtPos(pos).node.getBoundingClientRect();
    }
    return view.coordsAtPos(pos);
};
/**
 * 跟随式toolbar
 * - 定位规则
 *  + 有文字内容时展示，优先显示在选区上方
 *  + 跨行选中时，根据鼠标松开的位置来决定显示在上方或者是下方
 *  + 拖动选中，鼠标松开的位置与选区差距过大时，优先在鼠标松开的位置显示，并保持左右位置
 *  + 其他有选区但是没有工具栏的情况，移动鼠标出现，以鼠标位置为中心显示
 */
var ToolbarInlineLoader = /** @class */ (function (_super) {
    __extends(ToolbarInlineLoader, _super);
    // @ts-ignore
    function ToolbarInlineLoader(adapter, originOption) {
        var _this = this;
        _this._visible = true;
        _this.mousedown = false;
        _this.preferDir = 'up'; // 保持在选区上面或者是下面
        _this.preferLeft = 'auto'; // 保持left的位置是否固定
        _this._isEnable = true;
        _this.enable = function () {
            _this.isEnable = true;
        };
        _this.disable = function () {
            _this.isEnable = false;
        };
        _this.show = function () {
            _this.visible = true;
        };
        _this.hide = function () {
            _this.visible = false;
        };
        _this.checkHide = debounce(function () {
            if (!_this.adapter.isFocused && document.activeElement && !document.activeElement.closest(IGNORE_CLOSE_ATTRIBUTE)) {
                _this.hide();
            }
        }, 300);
        _this.handleMouseUp = function (e) {
            // 只处理在编辑器按下了鼠标的情况
            if (!_this.mousedown)
                return;
            _this.mousedown = false;
            _this.tracePos(e, true);
        };
        _this.handleMouseDown = function (e) {
            var button = e.button;
            if (button !== 2) {
                _this.mousedown = true;
                _this.hide();
            }
        };
        _this.tracePos = debounce(function (e, force) {
            if (!_this.isEnable || !_this.adapter.editable) {
                if (_this.visible)
                    _this.visible = false;
                return;
            }
            if (_this.mousedown)
                return;
            var view = _this.adapter.view;
            var state = view.state;
            var _a = state.selection, from = _a.from, to = _a.to, empty = _a.empty;
            if (empty ||
                !_this.adapter.getText({ index: from, length: to - from }).trim() ||
                _this.adapter.view.state.selection instanceof prosemirror_state_1.NodeSelection ||
                (_this.option.judgeShow && !_this.option.judgeShow(_this.adapter))) {
                _this.hide();
                return;
            }
            var visible = _this.visible;
            var dir = visible ? _this.preferDir : undefined;
            _this.show();
            _this.dom.style.visibility = 'hidden';
            // 根据宽高和在屏幕的位置计算位置，记得考虑编辑器本身的位置
            requestAnimationFrame(function () {
                var _a = state.selection, $head = _a.$head, $anchor = _a.$anchor;
                if (state.selection instanceof prosemirror_state_1.AllSelection) {
                    $anchor = state.doc.resolve(1);
                    var endPos = state.doc.nodeSize - 1;
                    while (endPos--) {
                        $head = state.doc.resolve(endPos);
                        if ($head.node().isTextblock)
                            break;
                    }
                    // 表格都显示在上方
                    // @ts-ignore
                }
                else if (state.selection.$anchorCell) {
                    var ranges = state.selection.ranges.sort(function (a, b) { return a.$from.pos - b.$from.pos; });
                    $anchor = ranges[0].$from;
                    $head = ranges[0].$to;
                }
                var _b = _this.threshold, thresholdTop = _b.top, thresholdLeft = _b.left, thresholdRight = _b.right, thresholdBottom = _b.bottom;
                var _c = getPosRect(view, $head.pos), headTop = _c.top, headLeft = _c.left, headBottom = _c.bottom;
                var _d = getPosRect(view, $anchor.pos), anchorBottom = _d.bottom, anchorTop = _d.top;
                var topPos = Math.min(headTop, anchorTop); // 选区最靠上的位置
                var bottomPos = Math.max(headBottom, anchorBottom); // 选区最靠下的位置
                var _e = _this.dom, offsetHeight = _e.offsetHeight, offsetWidth = _e.offsetWidth, offsetLeft = _e.offsetLeft;
                var domOffsetLeft = offsetWidth / 2;
                var _f = _this.adapter.root.getBoundingClientRect(), editorTop = _f.top, editorLeft = _f.left, editorRight = _f.right;
                var maxTop = window.innerHeight - offsetHeight - thresholdBottom;
                var minLeft = thresholdLeft;
                var maxLeft = editorRight - editorLeft - offsetWidth - thresholdRight; // 最大的left，与thresholdRight相关
                var defaultLeft = headLeft - domOffsetLeft - editorLeft; // 居中对齐head所在位置的left
                var computedTop = topPos - offsetHeight - 8;
                _this.preferDir = 'up';
                // 小于最小高度，跨行选中且未显示时，根据head与anchor的位置判断, 显示在下方
                if (computedTop < thresholdTop ||
                    (dir !== 'up' && Math.abs(anchorBottom - headBottom) > 12 && $head.pos > $anchor.pos)) {
                    computedTop = bottomPos + 8;
                    _this.preferDir = 'down';
                }
                // 超过最大高度，显示在上面
                if (computedTop > maxTop) {
                    computedTop = topPos - offsetHeight - 8;
                    _this.preferDir = 'up';
                }
                _this.dom.style.top = computedTop - editorTop + "px";
                // 鼠标点击,其他类型检查
                if (e instanceof Event || !visible) {
                    var target = void 0;
                    var pageX = void 0;
                    if (e instanceof Event) {
                        target = e.target;
                        pageX = e.pageX;
                    }
                    else {
                        target = _this.adapter.view.dom;
                        pageX = domOffsetLeft;
                    }
                    // 编辑器内时需要调整
                    if (_this.adapter.view.dom.contains(target)) {
                        var mouseLeft = (visible ? offsetLeft + editorLeft : pageX - domOffsetLeft) - editorLeft; // 鼠标定位，此时如果为visible，应该保持
                        var computedLeft = defaultLeft;
                        _this.preferLeft = 'auto';
                        // 判断应该使用光标的位置还是使用鼠标的位置, magic-number
                        if (Math.abs(mouseLeft - defaultLeft) >= 20) {
                            computedLeft = mouseLeft;
                            _this.preferLeft = 'fixed';
                        }
                        if (computedLeft >= maxLeft) {
                            _this.preferLeft = 'auto';
                            computedLeft = maxLeft;
                        }
                        else if (computedLeft <= minLeft) {
                            _this.preferLeft = 'auto';
                            computedLeft = minLeft;
                        }
                        _this.dom.style.left = computedLeft + "px";
                    }
                }
                else if (force || _this.preferLeft === 'auto') {
                    _this.preferLeft = 'auto';
                    // 强制刷新，缩进，撤销时调整位置
                    _this.dom.style.left = Math.min(maxLeft, Math.max(minLeft, defaultLeft)) + "px";
                }
                _this.dom.style.visibility = '';
            });
        }, 20);
        // 在其他情况下，检查是否需要显示toolbar
        _this.checkShow = throttle(function (e) {
            if (_this.visible || !_this.adapter.isFocused) {
                return;
            }
            _this.tracePos(e);
        }, 20);
        // 点击保持聚焦状态，防止隐藏
        _this.focusEditor = function () { return requestAnimationFrame(function () { return _this.adapter.focus(); }); };
        var option = Object.assign({}, originOption);
        _this = _super.call(this, adapter, option) || this;
        _this.option = option;
        _this.dom = document.createElement('div');
        adapter.root.appendChild(_this.dom);
        _this.dom.style.position = 'absolute';
        _this.dom.style.userSelect = 'none';
        _this.dom.style.display = 'none';
        _this.dom.style.zIndex = "" + (option.zIndex || 100);
        _this.visible = false;
        _this.bridge = new option.RenderBridge(adapter, option.Component, _this.dom, 'toolbarInline');
        _this.bindEvent();
        _this.render();
        adapter.addCommand('toolbarInline', {
            show: function () { return _this.tracePos(undefined, true); },
            hide: _this.hide,
            getVisible: function () { return _this.visible; },
            enable: _this.enable,
            disable: _this.disable
        });
        return _this;
    }
    Object.defineProperty(ToolbarInlineLoader.prototype, "isEnable", {
        get: function () {
            return this._isEnable;
        },
        set: function (val) {
            if (val === this._isEnable)
                return;
            if (!val)
                this.visible = false;
            this._isEnable = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolbarInlineLoader.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (val) {
            var _this = this;
            if (!val && this._visible === val)
                return;
            this._visible = val;
            var newProps = { visible: val };
            if (val) {
                this.dom.style.display = 'block';
                newProps.activeFormat = this.updateFormat(false);
                // 在内容发生变化的时候同步一下显示的位置
                this.adapter.on(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE, this.tracePos);
                this.adapter.view.dom.removeEventListener('mousemove', this.checkShow);
            }
            else {
                this.dom.style.display = 'none';
                this.adapter.off(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE, this.tracePos);
                // 在撤销或者重做，粘贴等情况下，判断是否需要显示
                this.adapter.view.dom.addEventListener('mousemove', this.checkShow);
            }
            // 为了优先渲染出dom，再更新props，便于实现动画效果
            requestAnimationFrame(function () { return _this.bridge.setProps(newProps); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolbarInlineLoader.prototype, "threshold", {
        // 最小边距
        get: function () {
            return __assign({ top: 0, left: 0, right: 0, bottom: 0 }, (this.option.threshold || {}));
        },
        enumerable: true,
        configurable: true
    });
    ToolbarInlineLoader.prototype.updateFormat = function (exec) {
        if (exec === void 0) { exec = true; }
        var activeFormat = this.adapter.getFormat();
        return exec ? this.bridge.setProps({ activeFormat: activeFormat }) : activeFormat;
    };
    ToolbarInlineLoader.prototype.bindEvent = function () {
        document.body.addEventListener('mouseup', this.handleMouseUp);
        this.adapter.view.dom.addEventListener('mousedown', this.handleMouseDown);
        // hack，drop时不触发mouseUp
        this.adapter.root.addEventListener('drop', this.handleMouseUp);
        this.adapter.on(core_utilities_1.EventChannel.LocalEvent.ON_BLUR, this.checkHide);
        this.dom.addEventListener('click', this.focusEditor);
    };
    ToolbarInlineLoader.prototype.setProps = function (_a) {
        var option = _a.option;
        this.option = __assign(__assign({}, this.option), option);
        this.render();
    };
    ToolbarInlineLoader.prototype.render = function () {
        this.bridge.setProps({
            editor: this.adapter,
            option: this.option,
            visible: false,
            activeFormat: {},
            toolbarLib: new __1.ToolbarLib({ editor: this.adapter, option: this.option })
        });
    };
    ToolbarInlineLoader.prototype.destructor = function () {
        document.body.removeEventListener('mouseup', this.handleMouseUp);
        this.adapter.view.dom.removeEventListener('mousedown', this.handleMouseDown);
        this.adapter.off(core_utilities_1.EventChannel.LocalEvent.ON_BLUR, this.checkHide);
        this.dom.removeEventListener('click', this.focusEditor);
        this.adapter.root.removeEventListener('drop', this.handleMouseUp);
        this.adapter.root.removeChild(this.dom);
        this.bridge.unmount();
    };
    return ToolbarInlineLoader;
}(core_utilities_1.BaseModule));
exports.ToolbarInlineLoader = ToolbarInlineLoader;
//# sourceMappingURL=toolbar-loader.js.map